import { render, staticRenderFns } from "./CatalogUninstallDialog.vue?vue&type=template&id=4e3293b6&scoped=true&"
import script from "./CatalogUninstallDialog.vue?vue&type=script&lang=js&"
export * from "./CatalogUninstallDialog.vue?vue&type=script&lang=js&"
import style0 from "./CatalogUninstallDialog.vue?vue&type=style&index=0&id=4e3293b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3293b6",
  null
  
)

export default component.exports